define(`Modules/ParallaxBlur`, [`Module`, `module`], function (Super, Self) {
	return Super.inherit({
		namespace: Self.id,
		requires: [`XHR`],
		defaults: {
			backgroundImageUrl: null, // Url for image resource
			maxScroll: 700, // maximum amount of scrolling before filters stop increasing (in px)
			maxBlur: 50, // maximum amount of blur applied (in px)
			maxScale: 1.3, // maximum amount of scaling
			minScale: 1, // minimum amount of scaling
			transformElementArray: null, // Elements to apply scaling to
			render: true,
		},
		prepare(setup) {
			const { System, data } = this;
			const { backgroundImageUrl, maxScroll, maxBlur, maxScale, minScale, scrollContainer, transformElementArray } =
				setup;
			const system = System.get();
			const { isMobile } = system;

			this.assign(data, {
				backgroundImageUrl,
				isMobile,
				maxScroll,
				maxBlur,
				maxScale,
				minScale,
				scrollContainer,
				transformElementArray,
			});
		},
		constructor: function (setup) {
			const { data } = this;

			data.imageElement = this.get(`.background`);
			this.onScroll();
			this.App.onScroll(this.onScroll);
		},
		api: {
			onScroll: {
				value() {
					const { DOM, Utils, data } = this;
					const {
						imageElement,
						isMobile,
						maxScroll,
						maxBlur,
						maxScale,
						minScale,
						scrollContainer,
						transformElementArray,
					} = data;
					const scrollAmount = -DOM.getDimensions(scrollContainer).viewportTop;

					// App.onScroll can get triggered on transition end on mobile, this can result in 0 when it shouldn't be
					if (isMobile && scrollAmount === 0 && Math.abs(scrollAmount - data.lastScrollAmount) > 300) {
						data.lastScrollAmount = scrollAmount;
						return;
					}

					// add a little buffer
					if (scrollAmount <= maxScroll + 200) {
						const scrollRatio = scrollAmount / maxScroll;
						const opacityScrollRatio = scrollAmount / (maxScroll / 2);
						const blurAmount = Utils.lerp(0, maxBlur, scrollRatio);
						const scaleAmount = Utils.lerp(minScale, maxScale, scrollRatio);
						const opacity = Utils.lerp(1, 0.5, opacityScrollRatio);

						if (imageElement != null) {
							imageElement.style.transform = `scale(${scaleAmount})`;
							imageElement.style.opacity = opacity;
							this.container.style.filter = `blur(${blurAmount}px)`;
						}

						if (this.isArray(transformElementArray, 1)) {
							for (let i = 0; i < transformElementArray.length; i++) {
								transformElementArray[i].style.transform = `scale(${scaleAmount})`;
								transformElementArray[i].style.filter = `blur(${blurAmount}px)`;
							}
						}
					}

					data.lastScrollAmount = scrollAmount;
				},
			},

			updateTransformElementArray: {
				public: true,
				value(transformElementArray) {
					this.data.transformElementArray = transformElementArray;
				},
			},
		},
	});
});

define("Modules/ParallaxBlur.templates",["handlebars"], function(Handlebars) {

this["Templates"] = this["Templates"] || {};

this["Templates"]["Modules/ParallaxBlur/main"] = Handlebars.template({"1":function(container,depth0,helpers,partials,data) {
    var lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return " <div class=\"background\" style=\"background-image:url('"
    + container.escapeExpression(container.lambda((depth0 != null ? lookupProperty(depth0,"backgroundImageUrl") : depth0), depth0))
    + "');\"></div> ";
},"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"backgroundImageUrl") : depth0),{"name":"if","hash":{},"fn":container.program(1, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":1,"column":0},"end":{"line":1,"column":121}}})) != null ? stack1 : "")
    + " ";
},"useData":true});

return this["Templates"];

});
//# sourceMappingURL=ParallaxBlur.js.map